<script type="text/ecmascript-6">
    import DesignerQuestionHardwareSuite from "../DesignerQuestionHardwareSuite.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareSuite,
            SynsealQuestion,
        ],
    }
</script>
